import React from 'react'
import { Alert } from '@sonans/components'

interface Props {
    content: React.ReactNode
    className?: string
    color?: 'green' | 'pink' | 'yellow'
    icon?: boolean
    title?: string
}

export function Message({
    content,
    className = '',
    color = 'green',
    title = '',
}: Props) {
    const variantMap = {
        green: 'success',
        pink: 'error',
        yellow: 'warning',
    } as const

    const composedContent = title ? (
        <>
            <h3 className="text-lg font-medium mb-1">{title}</h3>
            {content}
        </>
    ) : content

    return (
        <Alert
            content={composedContent}
            variant={variantMap[color]}
            className={className}
        />
    )
}
